var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextStep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#15225D;}\n\t.st1{clip-path:url(#SVGID_00000120528091227631794780000010862626114122952351_);fill:#212D65;}\n\t.st2{fill:#212D65;}\n\t.st3{clip-path:url(#SVGID_00000183248727660840360790000009794805678343068307_);fill:#212D65;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 55.6,
    y: 262.4,
    width: 488.8,
    height: 75.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004529393557728171940000004886388208612929951_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000004529393557728171940000004886388208612929951_)",
      fill: "#212D65"
    },
    d: "M244,285.9l-16.6,22.4 c-0.9,1.2-2.6,1.5-3.8,0.6c-0.1-0.1-0.1-0.1-0.2-0.2l-7.7-7.2c-1.1-1.1-2.9-1-4,0.1c-1,1.1-1,2.8,0,3.9c0,0,0,0,0.1,0.1l12.4,11.6 c1.1,1,2.8,1,3.9-0.2c0.1-0.1,0.1-0.1,0.2-0.2l20.5-27.8c0.9-1.2,0.6-2.9-0.5-3.8c0,0-0.1-0.1-0.1-0.1 C246.7,284.3,244.9,284.6,244,285.9z M106.7,285.9l-16.6,22.4c-0.9,1.2-2.6,1.5-3.8,0.6c-0.1-0.1-0.1-0.1-0.2-0.2l-7.7-7.2 c-1.1-1.1-2.9-1-4,0.1c-1,1.1-1,2.8,0,3.9c0,0,0,0,0.1,0.1l12.4,11.6c1.1,1,2.8,1,3.9-0.2c0.1-0.1,0.1-0.1,0.2-0.2l20.5-27.8 c0.9-1.2,0.6-2.9-0.5-3.8c0,0-0.1-0.1-0.1-0.1C109.4,284.3,107.6,284.6,106.7,285.9z M368.6,329.2c15.9,0,28.7-13.1,28.7-29.2 c0-16.2-12.9-29.2-28.7-29.2c-15.9,0-28.7,13.1-28.7,29.2C339.9,316.2,352.8,329.2,368.6,329.2z M505.9,329.2 c15.9,0,28.7-13.1,28.7-29.2c0-16.2-12.9-29.2-28.7-29.2c-15.9,0-28.7,13.1-28.7,29.2C477.2,316.2,490.1,329.2,505.9,329.2z  M469.2,295.8c2-18.8,17.7-33.4,36.7-33.4c20.4,0,36.9,16.8,36.9,37.6c0,20.8-16.5,37.6-36.9,37.6c-19,0-34.7-14.6-36.7-33.4 l-63.9,0.3c-2.2,18.6-17.8,33.1-36.7,33.1c-18.8,0-34.4-14.4-36.6-32.9l-64.1,0.3c-2.4,18.4-17.9,32.6-36.6,32.6 c-18.7,0-34.1-14.1-36.6-32.5l-64.2,0.3c-2.6,18.2-18,32.1-36.5,32.1c-20.4,0-36.9-16.8-36.9-37.6c0-20.8,16.5-37.6,36.9-37.6 c19.4,0,35.4,15.3,36.8,34.7l63.7-0.3c1.6-19.3,17.5-34.4,36.8-34.4c19.3,0,35.1,15,36.8,34.2l63.8-0.3c1.8-19,17.6-33.9,36.7-33.9 c19.1,0,34.8,14.8,36.7,33.8L469.2,295.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextStep);
export default __webpack_public_path__ + "static/media/next_step.9ee3d84d23ffb728ad6dcf2f0f47d886.svg";
export { ForwardRef as ReactComponent };